import app from './app'
import api from './api'
import micro from './micro'
import widgets from './widgets'
import components from './components'

export default {
  app,
  api,
  micro,
  components,
  widgets
}
